import { bl_job_processor_ext_RowClass } from "../../dbschema/bl_job_processor_ext.model";
import { bl_job_processor_hdr_RowClass } from "../../dbschema/bl_job_processor_hdr.model";
import { BaseContainerModel } from "../base-container.model";


export class JobProcessorContainerModel extends BaseContainerModel {
    bl_job_processor_hdr: bl_job_processor_hdr_RowClass = new bl_job_processor_hdr_RowClass();
    bl_job_processor_exts: bl_job_processor_ext_RowClass[] = [];
}